import { Add, Remove } from '@mui/icons-material';
import { Box, Button, Grid, Paper, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Recomandacoes } from '../../../services/api/action-plan/Aco';

interface RecommendationsProps {
    value: Recomandacoes[] | undefined
    onChange: (data: Recomandacoes[]) => void,
    smDown: boolean,
}

export const Recommendations = ({value, onChange, smDown}:RecommendationsProps) => {

    const [ dataSeps, setDataSteps ] = useState<Recomandacoes[]>([]);

    const handleAdd = () => {
        const newItem: Recomandacoes = {};
        setDataSteps(prevDataSteps => {
          const newDataSteps = [...prevDataSteps, newItem];
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    const handleRemove = () => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.slice(0, -1);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    const handleChange = (index: number, field: keyof Recomandacoes, value: string) => {
        setDataSteps(prevDataSteps => {
          const newDataSteps = prevDataSteps.map((item, i) => i === index ? { ...item, [field]: value } : item);
          onChange(newDataSteps);
          return newDataSteps;
        });
    };

    useEffect(() => {
        if (value) {
            setDataSteps(value);
        }
    }, []);

    return(
        <Box padding={1}>
            <Box display={'flex'} flexDirection={smDown ? 'column' : 'row'} justifyContent={'center'} gap={2} padding={1}>
                <Button
                    variant='outlined'
                    startIcon={<Add/>}
                    sx={{borderRadius: '25px'}}
                    onClick={handleAdd}
                >
                    Adicionar
                </Button>
                <Button
                    variant='outlined'
                    startIcon={<Remove/>}
                    sx={{borderRadius: '25px'}}
                    onClick={handleRemove}
                >
                    Remover
                </Button>
            </Box>

            {dataSeps.map((item, index) => (
                <Box padding={1} component={Paper} sx={{borderRadius: '25px'}} key={index} margin={2}>
                        <Grid container padding={2} spacing={2}>
                            <Grid item xs={6}>
                                <TextField
                                    label='Prazo'
                                    value={item.prazo}
                                    name='prazo'
                                    fullWidth
                                    type='date'
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => handleChange(index, 'prazo', e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label='Recomendações'
                                    value={item.recomendacao}
                                    name='recomendacao'
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => handleChange(index, 'recomendacao', e.target.value)}
                                />
                            </Grid>
                        </Grid>
                </Box>
            ))}
        </Box>
    );
};